module.exports = __webpack_public_path__ + "static/media/AA.d2a7e6e9.webp";